webpackJsonp([9],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "8un4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__("ukYY");

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__("lwq5");

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    state: _state2.default, mutations: _mutations2.default
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5b6c2de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("nKml");
function injectStyle (ssrContext) {
  __webpack_require__("8un4")
  __webpack_require__("pWTA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5b6c2de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

__webpack_require__("if7u");

__webpack_require__("pSyc");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.config.productionTip = false;

//绑定axios拦截器
// import axios from './axios'

// Vue.prototype.$http = axios;


//全局组件
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//过滤器


_router2.default.beforeEach(function (to, from, next) {
    if (to.path == "/login") {
        localStorage.removeItem("_token");
        localStorage.removeItem("user_info");
        next();
    } else {
        if (localStorage.getItem("_token") || to.path.indexOf("about") > -1) {
            next();
        } else {
            next({ path: '/login' });
        }
    }
});
new Vue({
    el: '#app',
    router: _router2.default,
    store: _store2.default,
    template: '<App/>',
    components: { App: _App2.default },
    methods: {
        changeInit: function changeInit() {
            window.scrollTo(0, 0);
        }
    },
    watch: {
        "$route": 'changeInit'
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "ToKV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * 自己常用的代码块
 * @type {{resultShengLue: xlhuang.resultShengLue, GetQueryString: xlhuang.GetQueryString, binarySystem: xlhuang.binarySystem, analysisBinarySystem: xlhuang.analysisBinarySystem}}
 */

var xlhuang = {

	/**
  * 将时间戳转化为xxxx-xx-xx 或 xxxx/xx/xx
  * @param value 时间戳
  * @param f   符号 '/' 或 '-'
  * @returns {*}
  */

	dateInit: function dateInit(value, f) {
		if (value != '' || value != undefined) {
			value = new Date(value);
			var year = value.getFullYear();
			var month = value.getMonth() + 1;
			var date = value.getDate();
			var hour = value.getHours();
			var minute = value.getMinutes();
			var second = value.getSeconds();
			return year + f + month + f + date;
		} else {
			return '--';
		}
	},

	/**
  * 保留几位小数
  * @param value 数字
  * @param num 保留几位
  * @returns {*}
  */

	keepDecimal: function keepDecimal(value, num) {
		if (value != "" || value != undefined) {
			value = parseFloat(value);
			if (isNaN(value)) {
				return "--";
			} else {
				num = num ? parseInt(num) : 0;
				if (num <= 0) return Math.round(value);
				value = Math.round(value * Math.pow(10, num)) / Math.pow(10, num);
				return value;
			}
		} else {
			return '--';
		}
	},

	/**
  * 带标签的文本转化为纯字符串
  * @returns {*}
  */
	formateHtml: function formateHtml(value) {
		if (value != "" || value != undefined) {
			var str = $(value).html();
			if (str.length > 60) {
				str = str.slice(0, 60) + "...";
			}
			return str;
		} else {
			return '无数据';
		}
	},

	/**
  * js截取字符串，中英文都能用
  * @param str：需要截取的字符串
  * @param len: 需要截取的长度
  */

	resultShengLue: function resultShengLue(str, len) {
		var str_length = 0;
		var str_len = 0;
		str_cut = new String();
		str_len = str.length;
		for (var i = 0; i < str_len; i++) {
			a = str.charAt(i);
			str_length++;
			if (escape(a).length > 4) {
				//中文字符的长度经编码之后大于4
				str_length++;
			}
			str_cut = str_cut.concat(a);
			if (str_length >= len) {
				str_cut = str_cut.concat("...");
				return str_cut;
			}
		}
		//如果给定字符串小于指定长度，则返回源字符串；
		if (str_length < len) {
			return str;
		}
	},

	/**
  * 获取url属性
  * GetQueryString("id")// 传入参数名
  */

	GetQueryString: function GetQueryString(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	},

	/**
  * 二进制传递
  * @param str
  * @returns {string}
  */
	binarySystem: function binarySystem(str) {
		var total2str = "";
		for (var i = 0; i < str.length; i++) {
			var num10 = str.charCodeAt(i); ///< 以10进制的整数返回 某个字符 的unicode编码
			var str2 = num10.toString(2); ///< 将10进制数字 转换成 2进制字符串
			if (total2str == "") {
				total2str = str2;
			} else {
				total2str = total2str + " " + str2;
			}
		}
		return total2str;
	},

	/**
  * 解析二进制
  * @param str
  * @returns {string}
  */
	analysisBinarySystem: function analysisBinarySystem(str) {
		var goal = "";
		var arr = str.split(' ');
		for (var i = 0; i < arr.length; i++) {
			var str2 = arr[i];
			var num10 = parseInt(str2, 2); ///< 2进制字符串转换成 10进制的数字
			goal += String.fromCharCode(num10); ///< 将10进制的unicode编码, 转换成对应的unicode字符
		}
		return goal;
	}

};

module.exports = xlhuang;

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
    mode: 'history',
    routes: [{
        path: '/',
        name: '/',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8hXn")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        redirect: '/lists',
        children: [{
            path: 'lists',
            name: 'lists',
            meta: {
                isLogin: true
            },
            title: '残疾人列表',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SgeB")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'peple/:id',
            name: 'peple',
            meta: {
                isLogin: true
            },
            title: '新建残疾人',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nrW0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: 'disability/:id',
            name: 'disability',
            meta: {
                isLogin: true
            },
            title: '残疾人详情',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2dK+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }]
    }, {
        path: '/login',
        name: 'login',
        title: '登录',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("T+/8")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/about/agreement',
        name: 'agreement',
        title: '用户协议',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LMHo")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/about/privacy',
        name: 'privacy',
        title: '隐私政策',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GS9Z")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '*',
        name: '404',
        title: '404',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JCBi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
});

/***/ }),

/***/ "if7u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// import Vue from 'vue'

//全局组件


// import notFind from "../../components/commom/BaseEmpty.vue"
//
// Vue.component("not-find",notFind);


/***/ }),

/***/ "lwq5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {};

exports.default = state;

/***/ }),

/***/ "nKml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pSyc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _xlhuang = __webpack_require__("ToKV");

var _xlhuang2 = _interopRequireDefault(_xlhuang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//将时间戳转化为xxxx-xx-xx 或 xxxx/xx/xx
// @param value 时间戳
// @param f   符号 '/' 或 '-'
Vue.filter("dateInit", function (value, f) {
  return _xlhuang2.default.dateInit(value, f);
});

//保留几位小数
// * @param value 数字
// * @param num 保留几位

// 过滤器
Vue.filter("keepDecimal", function (value, num) {
  return _xlhuang2.default.keepDecimal(value, num);
});

// * js截取字符串，中英文都能用
// * @param str：需要截取的字符串
// * @param len: 需要截取的长度
Vue.filter("resultShengLue", function (str, len) {
  return _xlhuang2.default.resultShengLue(str, len);
});

// 获取url属性
// * GetQueryString("id")// 传入参数名
Vue.filter("GetQueryString", function (name) {
  return _xlhuang2.default.GetQueryString(name);
});

//test ceshi
Vue.filter("test", function (val) {
  alert((0, _stringify2.default)(val));
});

/***/ }),

/***/ "pWTA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__("lbHh");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {

    //
    // //是否登录
    // isLogin (state, userMessage) {
    //     //userMessage用户信息
    //     if (userMessage) {
    //         Cookies.set("_user", userMessage, {expires: 7, path: '/'})
    //         state.isLogin = true;
    //
    //     } else {
    //         state.isLogin = false;
    //         Cookies.remove('_user', {path: '/'})
    //     }
    // },
    //

};

exports.default = mutations;

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'app'
};

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/dist.47222018f46825a655bf.js